var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLikeActive = function SvgLikeActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8.485a1.959 1.959 0 00-1.956-1.956h-4.719l.687-1.874a.61.61 0 00.006-.018c.331-.993.248-2.035-.24-3.014A2.151 2.151 0 0011.842.427h-.23c-.555 0-1.024.434-1.069.988a4.199 4.199 0 01-1.169 2.582L5.597 7.833h-.38v-.652a.652.652 0 00-.652-.652H.652A.652.652 0 000 7.18v11.74c0 .36.292.652.652.652h3.913c.36 0 .652-.293.652-.653v-.652h10.87a1.959 1.959 0 001.704-2.916 1.957 1.957 0 00.653-2.609 1.957 1.957 0 00.652-2.609c.543-.348.904-.957.904-1.649zm-16.087 0V18.268H1.304V7.833h2.609v.652z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLikeActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/likeActive.b6be6c40.svg";
export { ForwardRef as ReactComponent };